module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-regular.f19e155.woff";